module.exports = __webpack_public_path__ + "ce45f4f904927252f79c06a1d3d75d73.png";